export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export const changelog: ChangelogEntry[] = [
  {
    version: '0.15.0-beta.4',
    date: '2026-09-01',
    changes: [
      '修复并恢复 Komodo 自动更新策略，避免发布链路遗漏可用镜像',
      '新增百度站点验证元数据，补齐站点索引与验证能力',
      '升级 `docker/setup-buildx-action` 至 4.3.0，增强 CI 构建环境一致性',
    ],
  },
  {
    version: '0.15.0-beta.3',
    date: '2026-08-19',
    changes: [
      '升级前后端、实时通信和浏览器运行依赖，并完成新版本所需的构建配置迁移',
      '升级后的多人对局、刷新重连、离线恢复和管理功能已通过完整自动化回归',
      '本次更新不清空房间与对局数据，服务重启后玩家仍可刷新并继续游戏',
    ],
  },
  {
    version: '0.15.0-beta.2',
    date: '2026-08-19',
    changes: [
      '作弊终止提示会一直保留到玩家点击继续，不再被房间清理流程提前关闭',
      '管理后台标记作弊后，房间解散、玩家通知和返回大厅现在按统一顺序完成',
      '更新后的旧页面会明确提示刷新，避免新旧协议混用造成异常',
    ],
  },
  {
    version: '0.15.0-beta.1',
    date: '2026-08-18',
    changes: [
      '管理后台改为紧凑的信息界面，统一中文并删除多余的宣传文案和装饰设计',
      '管理后台新增服务器、账号凭据、房间座位与规则、对局阶段和 AI 引擎运行信息',
      '用户管理新增在线状态、连接数量、当前房间、最近登录和 API 密钥最近使用时间',
      '测试版与正式版支持独立更新通道，测试版发布不会影响正式版 latest',
    ],
  },
  {
    version: '0.15.0-beta.0',
    date: '2026-08-18',
    changes: [
      '0.15 首个公开测试版：重点验证房间生命周期、重启恢复和自动发版',
      '新增社区 AI 插件：房间内可选择已启用的自定义 AI Provider',
      '服务重启后可恢复房间与对局快照，同版本玩家刷新后继续游戏',
      '修复牌堆耗尽与复杂村规组合可能造成的回合卡死和自动操作死循环',
      '修复 10 人满员时观战房主无法移除成员、移交房主或继续下一轮的问题',
      '重构抢座、离房、观战、重连和房主迁移流程，减少幽灵成员与状态分叉',
    ],
  },
  {
    version: '0.14.0',
    date: '2026-07-27',
    changes: [
      '断网不再毁掉对局：全员同时掉线有完整 5 分钟重连宽限，回来接着打',
      '断线遮罩新增「重新连接」按钮，网络恢复还会自动重连——告别永久卡死',
      '服务器重启后重连即恢复对局：回合、投票、blitz 时限、房主都自动接续',
      '修复换账号后可能看到上一账号手牌的问题，登出清理更彻底',
      '修复「开始游戏」双击可能开出两副牌、抢座失败后从房间"人间蒸发"的问题',
      '多标签页登录互踢死循环修复：新标签页接管会话，旧标签页安静退场',
      '聊天记录不再串进下一个房间；对局中按返回键不再误触发重连',
      '等待室新增断线提示横幅，连接状态一目了然',
    ],
  },
  {
    version: '0.13.1',
    date: '2026-07-26',
    changes: [
      '人机变聪明了：不再乱打会被必胜质疑的 +4，残局还会算必胜出牌顺序',
      '人机连打同数字时零散色先甩、主色收尾，选色也不再固定偏红',
      '修复淘汰制：被淘汰的玩家不再「诈尸」获得回合摸牌',
      '修复淘汰制下 0 牌轮转、连环炸弹、7 牌换手会波及已淘汰玩家的问题',
    ],
  },
  {
    version: '0.13.0',
    date: '2026-07-26',
    changes: [
      '曲库上新 3 首原创 BGM：大厅华尔兹 Carousel、对决曲 Showdown、摇摆爵士 Cardsharp',
      'Carousel 是曲库第一首 3/4 拍圆舞曲，Cardsharp 是第一首摇摆爵士',
      '结算板焕新：奖牌色排名徽章 + 冠军皇冠，胜负一目了然',
      '对局玩家列表焕新：回合指示条、UNO 红色告警、断线红点',
      '个人信息弹窗重构为分组卡片，信息更清晰',
      '修复游戏曲 Pulse 鼓点与旋律错位的问题',
    ],
  },
  {
    version: '0.12.0',
    date: '2026-07-26',
    changes: [
      '新增卡面主题：复古经典 / 极简扁平 / 霓虹暗黑三套全新卡面，大厅设置中一键切换',
      '终局不再秒切结算：保留牌桌 10 秒看清最后一张牌，还能继续扔表情',
      '可扔表情新增 🐷 猪猪',
      '转向牌换上经典双箭头图标，不再和禁止牌傻傻分不清',
      'Passkey 登录修复：反代部署下注册/验证不再失败',
    ],
  },
  {
    version: '0.11.0',
    date: '2026-07-26',
    changes: [
      '移动端全新体验：玩家罗盘自动跟随当前回合，观战底部控制坞',
      '手牌手势：按住滑动选牌，上滑拖出手牌区松手打出，双指捏合调间距',
      '性能大幅优化：对局更流畅，手机不再发烫',
      '动画系统重写：摸牌/出牌/投掷飞行更自然连贯',
      '全部界面整体等比缩放适配屏幕，弹窗与控件视觉统一',
      '游戏字体统一为内置 Fredoka，全平台显示一致',
      '设置弹窗改为 Tab 分类导航，大厅可直接观战进行中的对战',
    ],
  },
  {
    version: '0.10.0',
    date: '2026-05-22',
    changes: [
      '新增 Passkey 免密码登录，支持指纹、面容和安全密钥',
      '个人设置中可管理已绑定的 Passkey',
      '全局视觉重构：深色主题 + 金色色系',
      '大厅、登录、注册页面全面重构',
      '响应式优化，移动端体验提升',
    ],
  },
  {
    version: '0.9.1',
    date: '2026-05-20',
    changes: [
      '修复加入房间后座位不显示的问题',
      '修复游戏开始后部分玩家误入观战视角',
      '修复踢掉线玩家后观战席出现幽灵在线观众',
      '回合结束掉线玩家现在会自动投票下一轮',
    ],
  },
  {
    version: '0.9.0',
    date: '2026-05-19',
    changes: [
      '客户端更新检测：Caddy 重启后自动提示刷新',
      '头像裁切支持自定义旋转角度',
      '注册/登录安全增强',
      'Bot 名字库扩充至 156 个',
      '修复头像裁切空白、浮动面板样式等问题',
    ],
  },
  {
    version: '0.8.0',
    date: '2026-05-19',
    changes: [
      '游戏计时器：回合计时与延迟实时显示',
      '移动端游戏布局适配与托管遮罩',
      '可拖拽悬浮面板、玩家列表折叠',
      '观战房主自动排队入座，房主迁移流程完善',
      '修复末牌限制/空手赢不算对局卡死问题',
      '重连稳定性与连接速度优化',
    ],
  },
  {
    version: '0.7.0',
    date: '2026-05-16',
    changes: [
      '房间座位系统：圆桌布局，10 个固定座位决定上下家顺序',
      '选座与换座：点击空位入座，支持玩家间请求换座、与 Bot 直接换座',
      '座位右键菜单：空位可入座或添加 Bot，Bot 位可换座、调难度、移除',
      '设置面板改为右侧滑出抽屉，移动端自适应缩放',
      '断线标记：断线玩家显示图标并自动取消准备',
    ],
  },
  {
    version: '0.6.0',
    date: '2026-05-16',
    changes: [
      '新增 Bot AI (人机) 功能，支持添加 Bot 填充空位',
      '大厅房间列表改为实时推送，无需手动刷新',
      '服务器延迟测量精度提升（Socket.IO ping/ack）',
      'Bot UI/UX 优化：单步托管动画、房主迁移逻辑',
    ],
  },
  {
    version: '0.5.1',
    date: '2026-05-15',
    changes: [
      '性能优化：Bot 回合广播次数从 2-6 次降至 1 次',
      '性能优化：弃牌堆传输截断 + 客户端 re-render 大幅减少',
      '更新日志支持折叠，默认只显示最近 3 个版本',
    ],
  },
  {
    version: '0.5.0',
    date: '2026-05-15',
    changes: [
      '全量依赖升级：React 19、Vite 8、TypeScript 6 等',
      '修复服务端测试不依赖外部 Redis',
      'MCP 包已发布到 npm',
    ],
  },
  {
    version: '0.4.0',
    date: '2026-05-14',
    changes: [
      'MCP Server：AI 客户端可通过 MCP 工具加入游戏',
      '8-bit 程序化 BGM 系统：大厅音乐、房间 BGM、音乐厅',
      '观众席全面改版：可视化列表、丢表情、抓 UNO、加入/退出按钮',
      '新增抢出村规、随机座位村规',
      '牌堆耗尽自动洗牌回收弃牌堆',
      '连续超时自动托管、回合结束踢出未准备玩家',
      '反作弊系统 + 全屏警告 UI',
      '玩家操作菜单：移交房主、踢人、强制静音、音量调节',
      '浏览器通知、服务器版本更新提示',
      '选色光波、+4 全屏效果',
      '新手教程引导',
      'game over 后可返回房间继续游戏',
      '开始界面 overlay + 登录注册页面重设计',
      '修复客户端时钟偏差导致倒计时异常',
      '大量游戏逻辑修复和体验优化',
    ],
  },
  {
    version: '0.3.2',
    date: '2026-05-10',
    changes: [
      '回合结算改为投票制，票数过半才开始下一局',
      '弃牌堆完整同步，桌面展示最近 8 张堆叠效果',
      '罚摸和给牌改为逐张摸牌动画',
      'UNO 和抓 UNO 全屏特效',
      '游戏内音效反馈：出牌、罚牌、道具命中',
      '房间闲置自动解散',
      '聊天记录重连恢复',
      '修复叠加罚摸、变色 +4、观战会话恢复等多个 bug',
    ],
  },
  {
    version: '0.3.1',
    date: '2026-05-07',
    changes: [
      '头像下方小卡牌背面图示（手牌 < 8 张时）',
      '替换 mediasoup 语音为 Mumble 架构',
      '语音说话人头像绿色高亮、分人音量调节',
      '修复出牌前喊 UNO 被覆盖的 bug',
      '修复叠加村规下万能牌逃脱惩罚的 bug',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-05-07',
    changes: [
      '管理后台：用户管理、房间管理、数据统计',
      '四级用户角色系统（普通/会员/VIP/管理员）',
      '椭圆轨道高亮弧段 + 出牌方向箭头',
      '回合指示器：当前玩家头像、昵称、倒计时',
      '托管增强：自动质疑 +4、自动选色、自动选交换对象',
      '圆角/科技双风格主题',
      '首页版本号、游戏 TopBar 版本号',
      '修复 passwordHash 泄露安全漏洞',
    ],
  },
  {
    version: '0.2.0',
    date: '2026-05-06',
    changes: [
      '用户名密码注册登录、昵称系统、头像上传',
      '椭圆圆桌布局：玩家节点环绕排列、倒计时圆环',
      '聊天气泡、快捷反应、快捷短语、扔道具互动',
      '扑克风格卡角、扇形手牌布局、自动排序',
      '自动托管（Bot）、抽牌动画、房间重连',
      '迁移 Tailwind CSS v4 暗色主题',
      '移除 Prisma，改用 Kysely + SQLite',
    ],
  },
  {
    version: '0.1.0',
    date: '2026-05-06',
    changes: [
      'UNO Online 初始版本',
      'React 客户端 + Node.js 服务端 + 共享游戏逻辑',
      '开发模式：跳过 GitHub OAuth，仅用户名登录',
      'Caddy 替换 nginx，支持自动 SSL',
    ],
  },
];
